import { render, staticRenderFns } from "./standPrepare.vue?vue&type=template&id=6f0febf8&scoped=true&"
import script from "./standPrepare.vue?vue&type=script&lang=js&"
export * from "./standPrepare.vue?vue&type=script&lang=js&"
import style0 from "./standPrepare.vue?vue&type=style&index=0&id=6f0febf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0febf8",
  null
  
)

export default component.exports